import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { selectUserProfile } from "../../Router/selectors";
import { createSelector } from "reselect";
export var selectClientConfig = function selectClientConfig(_ref) {
  var MainReducer = _ref.MainReducer;
  var profile = MainReducer.profile,
      pages = MainReducer.pages,
      reports = MainReducer.reports;
  return {
    profile: profile,
    pages: pages,
    reports: reports
  };
};
export var selectFirebaseConfig = function selectFirebaseConfig(_ref2) {
  var MainReducer = _ref2.MainReducer;
  return MainReducer.firebase;
};
export var selectReplacedReducers = function selectReplacedReducers(_ref3) {
  var MainReducer = _ref3.MainReducer;
  return MainReducer.replacedReducers;
};
export var selectConfig = function selectConfig(_ref4) {
  var MainReducer = _ref4.MainReducer;
  return MainReducer.config;
};
export var areJobpacksLoaded = function areJobpacksLoaded(_ref5) {
  var MainReducer = _ref5.MainReducer;
  return MainReducer.jobpacksLoaded;
};
export var areUsersLoaded = function areUsersLoaded(_ref6) {
  var MainReducer = _ref6.MainReducer;
  return MainReducer.usersLoaded;
};
export var areActivitiesLoaded = function areActivitiesLoaded(_ref7) {
  var MainReducer = _ref7.MainReducer;
  return MainReducer.activitiesLoaded;
};
export var areGroupsLoaded = function areGroupsLoaded(_ref8) {
  var MainReducer = _ref8.MainReducer;
  return MainReducer.groupsLoaded;
};
export var requestingJobs = function requestingJobs(_ref9) {
  var MainReducer = _ref9.MainReducer;
  return MainReducer.requestingJobs;
};
export var requestingActivities = function requestingActivities(_ref10) {
  var MainReducer = _ref10.MainReducer;
  return MainReducer.requestingActivities;
};
export var requestingUsers = function requestingUsers(_ref11) {
  var MainReducer = _ref11.MainReducer;
  return MainReducer.requestingUsers;
};
export var selectRoutes = createSelector([selectClientConfig, selectUserProfile, selectConfig], function (_ref12, _ref13, config) {
  var _ref12$pages = _ref12.pages,
      pages = _ref12$pages === void 0 ? false : _ref12$pages,
      _ref12$reports = _ref12.reports,
      reports = _ref12$reports === void 0 ? false : _ref12$reports;
  var _ref13$access_level = _ref13.access_level,
      access_level = _ref13$access_level === void 0 ? false : _ref13$access_level,
      _ref13$security_level = _ref13.security_level,
      security_level = _ref13$security_level === void 0 ? false : _ref13$security_level,
      _ref13$email = _ref13.email,
      email = _ref13$email === void 0 ? false : _ref13$email;

  if (pages === false || reports === false) {
    return false;
  }

  var allPages = pages.reduce(function (acc, curr) {
    switch (curr.type) {
      case "page":
        {
          acc.push(curr);
          break;
        }

      case "JM":
        {
          acc = [].concat(_toConsumableArray(acc), _toConsumableArray(curr.sub_pages));
          break;
        }

      case "RM":
        {
          acc = [].concat(_toConsumableArray(acc), _toConsumableArray(curr.sub_pages));
          break;
        }

      case "UM":
        {
          acc = [].concat(_toConsumableArray(acc), _toConsumableArray(curr.sub_pages));
          break;
        }

      case "REM":
        {
          acc = [].concat(_toConsumableArray(acc), _toConsumableArray(curr.sub_pages));
          break;
        }

      case "SU":
        {
          acc = [].concat(_toConsumableArray(acc), _toConsumableArray(curr.sub_pages));
          break;
        }

      case "PT":
        {
          acc = [].concat(_toConsumableArray(acc), _toConsumableArray(curr.sub_pages));
          break;
        }

      default:
        break;
    }

    return acc;
  }, []);
  var allPagesSecure = allPages.filter(function (e) {
    if (access_level && security_level && config && email) {
      if (email.toLowerCase().includes("@prowork") && e.access_level === "seated_users") return true;else if (email.toLowerCase().includes("@prowork") === false && e.access_level === "seated_users") return false;else return (config[access_level][e.access_level] ? config[access_level][e.access_level].read : true) && e.security_level.includes(security_level);
    } else return true && e.security_level.includes(security_level);
  });
  var allReportsSecure = reports.filter(function (e) {
    if (access_level && security_level && config) return (config[access_level][e.access_level] ? config[access_level][e.access_level].read : true) && e.security_level.includes(security_level);else return true && e.security_level.includes(security_level);
  });
  return [].concat(_toConsumableArray(allPagesSecure), _toConsumableArray(allReportsSecure));
});
export var selectMenuItems = createSelector([selectClientConfig, selectUserProfile, selectConfig], function (_ref14, _ref15) {
  var _ref14$pages = _ref14.pages,
      pages = _ref14$pages === void 0 ? false : _ref14$pages;
  var _ref15$access_level = _ref15.access_level,
      access_level = _ref15$access_level === void 0 ? false : _ref15$access_level,
      _ref15$security_level = _ref15.security_level,
      security_level = _ref15$security_level === void 0 ? false : _ref15$security_level,
      _ref15$email = _ref15.email,
      email = _ref15$email === void 0 ? false : _ref15$email;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (pages === false || access_level === false || security_level === false || config === false || email === false) {
    return false;
  }

  var allPages = pages.reduce(function (acc, curr) {
    switch (curr.type) {
      case "divider":
        {
          acc.push(curr);
          break;
        }

      case "page":
        {
          if ((config[access_level][curr.access_level] ? config[access_level][curr.access_level].read : true) && curr.security_level.includes(security_level)) {
            if (email.toLowerCase().includes("@prowork") && curr.access_level === "seated_users") acc.push(curr);else if (email.toLowerCase().includes("@prowork") === false && curr.access_level === "seated_users") {} else acc.push(curr);
          }

          break;
        }

      case "JM":
        {
          var subs = curr.sub_pages.filter(function (e) {
            if (email.toLowerCase().includes("@prowork") && e.access_level === "seated_users") return true;else if (email.toLowerCase().includes("@prowork") === false && e.access_level === "seated_users") return false;else return (config[access_level][e.access_level] ? config[access_level][e.access_level].read : true) && e.security_level.includes(security_level);
          });
          acc.push(_objectSpread({}, curr, {
            sub_pages: subs
          }));
          break;
        }

      case "RM":
        {
          var _subs = curr.sub_pages.filter(function (e) {
            if (email.toLowerCase().includes("@prowork") && e.access_level === "seated_users") return true;else if (email.toLowerCase().includes("@prowork") === false && e.access_level === "seated_users") return false;else return (config[access_level][e.access_level] ? config[access_level][e.access_level].read : true) && e.security_level.includes(security_level);
          });

          acc.push(_objectSpread({}, curr, {
            sub_pages: _subs
          }));
          break;
        }

      case "UM":
        {
          var _subs2 = curr.sub_pages.filter(function (e) {
            if (email.toLowerCase().includes("@prowork") && e.access_level === "seated_users") return true;else if (email.toLowerCase().includes("@prowork") === false && e.access_level === "seated_users") return false;else {
              var conf = config ? config[access_level] : false;
              conf = conf ? conf[e.access_level] : false;
              return (conf ? conf.read : true) && e.security_level.includes(security_level);
            }
          });

          acc.push(_objectSpread({}, curr, {
            sub_pages: _subs2
          }));
          break;
        }

      case "REM":
        {
          var _subs3 = curr.sub_pages.filter(function (e) {
            if (email.toLowerCase().includes("@prowork") && e.access_level === "seated_users") return true;else if (email.toLowerCase().includes("@prowork") === false && e.access_level === "seated_users") return false;else {
              var conf = config ? config[access_level] : false;
              conf = conf ? conf[e.access_level] : false;
              return (conf ? conf.read : true) && e.security_level.includes(security_level);
            }
          });

          acc.push(_objectSpread({}, curr, {
            sub_pages: _subs3
          }));
          break;
        }

      case "SU":
        {
          var _subs4 = curr.sub_pages.filter(function (e) {
            if (email.toLowerCase().includes("@prowork") && e.access_level === "seated_users") return true;else if (email.toLowerCase().includes("@prowork") === false && e.access_level === "seated_users") return false;else {
              var conf = config ? config[access_level] : false;
              conf = conf ? conf[e.access_level] : false;
              return (conf ? conf.read : true) && e.security_level.includes(security_level);
            }
          });

          acc.push(_objectSpread({}, curr, {
            sub_pages: _subs4
          }));
          break;
        }

      case "PT":
        {
          var _subs5 = curr.sub_pages.filter(function (e) {
            if (email.toLowerCase().includes("@prowork") && e.access_level === "seated_users") return true;else if (email.toLowerCase().includes("@prowork") === false && e.access_level === "seated_users") return false;else {
              var conf = config ? config[access_level] : false;
              conf = conf ? conf[e.access_level] : false;
              return (conf ? conf.read : true) && e.security_level.includes(security_level);
            }
          });

          acc.push(_objectSpread({}, curr, {
            sub_pages: _subs5
          }));
          break;
        }

      default:
        break;
    }

    return acc;
  }, []);
  return allPages;
});